import { render, staticRenderFns } from "./paymentAccountOpeningReview.vue?vue&type=template&id=4565e0c1&scoped=true"
import script from "./paymentAccountOpeningReview.vue?vue&type=script&lang=js"
export * from "./paymentAccountOpeningReview.vue?vue&type=script&lang=js"
import style0 from "./paymentAccountOpeningReview.vue?vue&type=style&index=0&id=4565e0c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4565e0c1",
  null
  
)

export default component.exports